import * as tslib_1 from "tslib";
import { action, select } from 'satcheljs/lib/legacy';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { getNow } from '../utils/getNow';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { lazyUserInitiatedWebPushDisableWorkflow, lazyLoadWebPushOptions, getLocalWebPushUserSettingStore, logDisableStart, logWorkFlowEnd, } from 'owa-webpush-notifications';
import { getOptionsForFeature, lazyCreateOrUpdateOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import strings from 'owa-strings/owa-options-strings';
export var tryDisableAllWebPushNotifications = function () {
    return confirm(strings.webpushDisableAllConfirmDialogHeader, strings.webpushDisableAllConfirmDialogBody, false, {}).then(function (response) {
        if (response === DialogResponse.ok) {
            disableAllWebPushNotifications();
        }
    });
};
var disableAllWebPushNotifications = select({
    userOptions: function () {
        return getOptionsForFeature(OwsOptionsFeatureType.WebPushNotifications);
    },
    localWebPushUserSetting: function () { return getLocalWebPushUserSettingStore(); },
    windowObj: function () { return window; },
})(action('disableAllWebPushNotifications')(function disableAllWebPushNotifications(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions, localWebPushUserSetting, windowObj, userInitiatedWebPushDisableWorkflow, loadWebPushOptions, disabled, _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    userOptions = state.userOptions, localWebPushUserSetting = state.localWebPushUserSetting, windowObj = state.windowObj;
                    userOptions.enabled = false;
                    localWebPushUserSetting.enabled = false;
                    userOptions.enabledTimeInUTCMs = getNow().toString();
                    return [4 /*yield*/, lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.WebPushNotifications, userOptions)];
                case 1:
                    _c.sent();
                    return [4 /*yield*/, lazyUserInitiatedWebPushDisableWorkflow.import()];
                case 2:
                    userInitiatedWebPushDisableWorkflow = _c.sent();
                    return [4 /*yield*/, lazyLoadWebPushOptions.import()];
                case 3:
                    loadWebPushOptions = _c.sent();
                    logDisableStart('settings', true);
                    _a = userInitiatedWebPushDisableWorkflow;
                    _b = [windowObj];
                    return [4 /*yield*/, loadWebPushOptions()];
                case 4: return [4 /*yield*/, _a.apply(void 0, _b.concat([_c.sent(),
                        getUserConfiguration().SessionSettings.MailboxGuid,
                        true]))];
                case 5:
                    disabled = _c.sent();
                    logWorkFlowEnd(disabled);
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=disableAllWebPushNotifications.js.map